export default "__VITE_ASSET__6e65592d__"